import { LoaContract } from "@/models"

export const isEmployeeValid = (contract: LoaContract) => {
  return (
    contract.employeeFirstName !== "" &&
    contract.employeeLastName !== "" &&
    contract.employeePosition !== ""
  )
}

export const isAuthorizerValid = (contract: LoaContract) => {
  return contract.firstName !== "" && contract.lastName !== "" && contract.position !== ""
}

export const isEmailValid = (email: string) => {
  const emailPattern = /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
  return emailPattern.test(email)
}

export const isPhoneNumberValid = (phoneNumber: string) => {
  const phoneNumberPattern = /^\+[0-9]{9,15}$/i
  return phoneNumberPattern.test(phoneNumber)
}

export const isSubmitDataValid = (contract: LoaContract) => {
  return isEmailValid(contract.email) && isPhoneNumberValid(contract.phoneNumber)
}
